import apiService from '@/services/apiService';

const actions = {
  getServicesMicrosites({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('microsite-service/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getServicesMicrosite({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`microsite-service/${payload}`)
        .then((response) => {
          resolve(response.data.data);
          commit('getServicesMicrosite', response.data.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  orderTncCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`tnc-category/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postServicesMicrosite({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('microsite-service', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putServicesMicrosite({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`microsite-service/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderServicesMicrosite({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`microsite-service/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delServicesMicrosite({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.delete(`microsite-service/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

};

export default actions;
